import type { Tracker } from './tracker'

// PV 自动追踪 + 页面浏览时长统计
export function initPvTracker(tracker: Tracker) {
  let activeTime = 0                // 累计前台有效时长（ms）
  let lastVisibleTime = Date.now()  // 上次页面可见的时间点

  // ── 可见性变化：暂停 / 恢复计时 ──────────────────────────
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      // 切到后台：累加本段前台时长
      activeTime += Date.now() - lastVisibleTime
    } else {
      // 切回前台：重置起点
      lastVisibleTime = Date.now()
    }
  })

  // ── 离开当前页面时上报 leave 事件 ────────────────────────
  function trackLeave() {
    // 若当前仍在前台，需把最后一段时间也算进去
    if (document.visibilityState !== 'hidden') {
      activeTime += Date.now() - lastVisibleTime
    }
    tracker.track('leave', { duration: activeTime })
  }

  // ── 路由切换时：先上报 leave，再上报新 PV ────────────────
  function onRouteChange() {
    trackLeave()
    // 重置计时器
    activeTime = 0
    lastVisibleTime = Date.now()
    tracker.track('pv')
  }

  const originalPush = history.pushState.bind(history)

  // 只拦截 pushState：replaceState 是静默更新 URL，不代表页面切换
  history.pushState = (...args) => {
    originalPush(...args)
    onRouteChange()
  }

  window.addEventListener('popstate', onRouteChange)

  // 页面关闭前上报（sendBeacon 保证不丢）
  window.addEventListener('beforeunload', () => {
    trackLeave()
    tracker.flush(true)
  })

  // 初始页面 PV
  tracker.track('pv')
}
